import { render, staticRenderFns } from "./Remove.vue?vue&type=template&id=77e4e924&scoped=true&"
import script from "./Remove.vue?vue&type=script&lang=js&"
export * from "./Remove.vue?vue&type=script&lang=js&"
import style0 from "./Remove.vue?vue&type=style&index=0&id=77e4e924&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77e4e924",
  null
  
)

export default component.exports